import { miniToolsClient } from "@/shared/lib/supabase";
import { getKeyOnlyQueryConfig } from "@/shared/lib/key-only-query-config";
import { queryOptions } from "@tanstack/react-query";
import type {
  Database,
  MiniToolRow,
  MiniToolSettingRow,
} from "@/types/supabase.types";

type MiniToolCategory = Database["mini_tools"]["Enums"]["tool_category_enum"];
type MiniToolStatus = Database["mini_tools"]["Enums"]["tool_status_enum"];

type MiniToolWithSettingRow = MiniToolRow & {
  mini_tool_setting: MiniToolSettingRow;
};

export type UiMiniToolItem = {
  id: string;
  name: string;
  description: string | null;
  url: string | null;
  category: MiniToolCategory;
  status: MiniToolStatus;
  setting: MiniToolSettingRow;
};

async function fetchMiniTools(): Promise<MiniToolWithSettingRow[]> {
  const { data, error } = await miniToolsClient
    .from("mini_tool")
    .select("*, mini_tool_setting(*)")
    .order("record_created", { ascending: false });

  if (error) throw error;
  return data ?? [];
}

function toUiItem(row: MiniToolWithSettingRow): UiMiniToolItem {
  return {
    id: row.mini_tool_id,
    name: row.tool_name,
    description: row.tool_description,
    url: row.tool_url,
    category: row.tool_category,
    status: row.tool_status,
    setting: row.mini_tool_setting,
  };
}

export const miniToolQueries = {
  all: getKeyOnlyQueryConfig(["mini-tools"]),

  lists: () => getKeyOnlyQueryConfig(["mini-tools", "list"]),

  list: () =>
    queryOptions({
      queryKey: [...miniToolQueries.lists().queryKey],
      queryFn: () => fetchMiniTools(),
      select: (data) => data.map(toUiItem),
    }),
};
